import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

let _enabledCache = null;
export const fetchCoachEnabled = async () => {
  if (_enabledCache === null) {
    _enabledCache = api.get("/coach/enabled").then(({ data }) => data.enabled !== false).catch(() => true);
  }
  return _enabledCache;
};

export const CoachFab = () => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const [enabled, setEnabled] = useState(true);
  useEffect(() => { fetchCoachEnabled().then(setEnabled); }, []);
  if (!enabled) return null;
  if (pathname.startsWith("/coach") || pathname.startsWith("/admin") || pathname.startsWith("/certificate")) return null;
  return (
    <button onClick={() => nav("/coach")} data-testid="coach-fab" title="Talk to Coach"
      className="fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#FFE01A] text-black font-bold text-sm pl-3.5 pr-4 py-2.5 border-0 cursor-pointer shadow-lg shadow-black/40 hover:scale-105 transition-transform">
      <Sparkle size={17} weight="duotone" /> Coach
    </button>
  );
};
